import { imageServiceConfig } from './image-optimization-config';
import { ImageOptimizer } from './image-optimiziation';

export const ImageSourceHelper = new ImageOptimizer(imageServiceConfig, {
  // Preferred width for images
  width: imageServiceConfig.defaultWidth,
  format: imageServiceConfig.defaultFormat,
});
